import Backbone from 'backbone'
import _ from 'underscore'
import HeaderViewTemplate from '../templates/header.tpl'
import HeaderUserView from './header-user'
import config from '../config'
import PromoCodeButtonView from './promo-code-button'
import user from '../user'

const HeaderView = Backbone.View.extend({
    tagName: 'div',
    initialize() {
        this.template = _.template(HeaderViewTemplate)
        this.listenTo(config, 'change:shortName', this.render)
    },
    render() {
        let appTitle = ''

        if (config.get('handheld')) {
            appTitle = config.get('shortName')
        } else {
            appTitle = config.get('name')
        }

        if (appTitle === '') {
            appTitle = 'Revision Hub'
        }

        // render the app title
        this.$el.html(this.template({text: appTitle}))

        // adds the login/register button to the header
        const headerUserView = new HeaderUserView()
        this.$('#header-user').append(headerUserView.render().el)

        // adds the promo code button to the header to just menu and profile
        const currentFragment = Backbone.history.fragment
        if (!['school', 'promo-code', 'free-book'].includes(currentFragment)) {
            const promoCodeButtonView = new PromoCodeButtonView();
            this.$('#promo-code-button').prepend(promoCodeButtonView.render().el);
        }

        return this
    }
})

export default HeaderView
